import { useLayoutEffect, useRef } from 'react';
import { observeResize } from '../../lib/observeResize';

/** Preserve every configured rule, using wrapping rather than single-line truncation. */
export function FittedLines({
  lines,
  size,
  color,
}: {
  lines: string[];
  size: number;
  color: string;
}) {
  const box = useRef<HTMLDivElement>(null);
  const content = useRef<HTMLDivElement>(null);
  const text = lines.join('\n');
  useLayoutEffect(() => {
    const container = box.current,
      block = content.current;
    if (!container || !block) return;
    const fit = () => {
      let low = 0,
        high = size;
      for (let i = 0; i < 12; i++) {
        const candidate = (low + high) / 2;
        block.style.fontSize = `${candidate}px`;
        if (
          block.scrollHeight <= container.clientHeight &&
          block.scrollWidth <= container.clientWidth
        )
          low = candidate;
        else high = candidate;
      }
      block.style.fontSize = `${low}px`;
    };
    const stop = observeResize(container, fit);
    let active = true;
    document.fonts?.ready.then(() => {
      if (active) fit();
    });
    return () => {
      active = false;
      stop();
    };
  }, [text, size]);
  return (
    <div
      ref={box}
      className="h-full w-full min-h-0 min-w-0 flex items-center overflow-hidden"
      data-fitted-lines
    >
      <div
        ref={content}
        className="w-full font-bold leading-snug whitespace-pre-line"
        style={{ fontSize: size, color, overflowWrap: 'anywhere' }}
      >
        {text}
      </div>
    </div>
  );
}
